import defaultHeaders from "../headers"
import { Response } from "../Model"
import client from "./client"

export enum DeviceType {
    MOBILE = `MOBILE`,
    WEB = `WEB`
}

export interface Company {
    name: string
    code?: string
    businessNature?: string
}

export interface Address {
    residentialStatus?: string
    postalCode?: string
    blockHSENo?: string
    floor?: string
    unit?: string
    street?: string
    buildingName?: string
}

export interface User {
    status: string
    scid?: string
    race: string
    officeTelNo?: string
    occupationalGroup?: string
    occupation?: string
    nricFin: string
    name: string
    monthlyGrossSalary?: number
    mobileNumber: string
    maritalStatus: string
    highestEducationLevel: string
    gender: string
    exchangeId?: string
    employmentType?: string
    email: string
    dob: string
    conflictUserId?: number
    company?: Company
    branchCode?: string
    bankName?: string
    bankCode?: string
    bankAccountNumber?: string
    address?: Address
}

export interface Membership {
    campaignCode?: string | undefined
    unionName?: string | undefined
    unionCode?: string | undefined
    ucemCreateStatus?: string | undefined
    status?: string | undefined
    optInNebo: boolean
    nameOnCard?: string | undefined
    deviceType: DeviceType
    referralCode?: string | undefined
    recruiterCode?: string | undefined
}

export interface UserMembershipRequest {
    user: User
    membership: Membership
}

export interface MembershipResponse {
    id: number | undefined
    createdDttm: Date
    membershipTypeCode: string
    modifiedDttm: Date
    status: string
    userId: number
    ucemCreateStatus: string
    campaignCode: string
    lastPaymentEndDate: Date
    lastPaymentStartDate: Date
    cardNumber: string
    nameOnCard: string
    ucemGiftGuid: string
    ucemUpdateStatus: string
    ucemMembershipGuid: string
    giftItemName: string
    createGift: boolean
    unionName: string
    unionCode: string
    startDate: Date
    relationship: string
    optInNebo: boolean
    createdBy: string
    modifiedBy: string
    lastPaidDate: Date
    deletedDttm: Date
    deletedBy: string
}

export interface UserMembershipResponse {
    user: User
    membership: MembershipResponse | undefined
}

// eslint-disable-next-line const-case/uppercase
const OPEN_MEMBERSHIP_ENDPOINT = `membership/open/oa`
const MEMBERSHIP_ENDPOINT = `membership/oa`
const membershipURL = () => {
    return window.myNtucConfig.authToken ? MEMBERSHIP_ENDPOINT : OPEN_MEMBERSHIP_ENDPOINT
}
const postMembershipOAData = (userMembership: UserMembershipRequest) => client
    .post<Response<UserMembershipResponse>>(membershipURL(), userMembership, { headers: defaultHeaders() })
    .then(response => response.data)

const updateMembershipOAData = (userMembership: UserMembershipRequest, membershipId: number) => client
    .patch<Response<UserMembershipResponse>>(membershipURL() + `/` + membershipId, userMembership, { headers: defaultHeaders() })
    .then(response => response.data)

export { postMembershipOAData, updateMembershipOAData }